import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {Store} from '@ngrx/store';
import {filter, take, tap} from 'rxjs/operators';
import { PartnerEntity } from '../entities/partner.entity';
import { State } from '../State';
import { getPartners } from '../State/selectors/partners.selectors';
import { PartnersActionTypes } from '../State/actions/partners.actions';

@Injectable({
    providedIn: 'root'
})
export class PartnerListResolver implements Resolve<PartnerEntity[]> {
    constructor(private store: Store<State>) {}

    resolve() {
        const value$ = this.store.select(getPartners);

        value$
            .pipe(
                filter(value => !value),
                take(1),
                tap(() => {
                    if (localStorage.getItem('token') != null) {
                        this.store.dispatch(PartnersActionTypes.LoadPartnerList());
                }
                })
            )
            .subscribe();

        return value$.pipe(
            filter(value => !!value),
            take(1)
        );
    }
}
